// validateExcelBlob.js

const validate = async (blob) => {
  const buffer = await blob.slice(0, 4).arrayBuffer();
  const bytes = new Uint8Array(buffer);
  return bytes[0] === 0x50 && bytes[1] === 0x4B && 
         bytes[2] === 0x03 && bytes[3] === 0x04;
};

export const validateExcelBlob = async (blob) => {
  const isValid = await validate(blob);
  
  if (!isValid) {
    console.error('Invalid Excel file');
    return null;
  }

  return URL.createObjectURL(blob);
};